<template>
  <v-tooltip v-model="tooltip" :disabled="!tooltip" v-if="!!value" bottom>
    <template v-slot:activator="{ on }">
      <span class="cursor-copy" v-on="on" @click="copyToClipboard" @mouseover="hover = true" @mouseleave="hover = false">
        <slot />
        <div class="copy-clipboard">
        <span v-if="hover" :ref="helpersRef" class="ml-1"><v-icon small>file_copy</v-icon></span>
        </div>
      </span>
    </template>
    Copied to clipboard!
  </v-tooltip>
</template>

<script>
export default {
  name: 'Clipboard',
  props: {
    value: String
  },
  data () {
    return {
      tooltip: false,
      timeout: null,
      hover: false
    }
  },
  computed: {
    helpersRef () {
      return `clipboard-${this._uid}`
    }
  },
  methods: {
    /**
     * Automatically copy the content to clipboard when clicking on it
     */
    copyToClipboard () {
      const elm = document.createElement('textarea')
      elm.value = this.value
      document.body.appendChild(elm)
      elm.select()
      document.execCommand('copy')
      document.body.removeChild(elm)
      this.tooltip = true
      this.timeout = setTimeout(() => {
        this.tooltip = false
      }, 800)
    }
  },
  beforeDestroy () {
    clearTimeout(this.timeout)
  }
}
</script>

<style lang="sass">
.cursor-copy
  cursor: copy
.copy-clipboard
  display: inline-block
  width: 18px
  height: 16px
  overflow: hidden
  margin-top: -4px
</style>
